module.exports = __webpack_public_path__ + "img/mitsubishi_thumbnail.ce01b1bf.png";